import { registerTourPage } from '@/composables/tour/tourRegistry';
import { step, introStep } from '@/composables/tour/stepHelpers';

registerTourPage('Subjects', {
  key: 'admin-subjects',
  label: 'Subjects',
  getSteps: () => [
    step({
      target: '#tour-subjects-create-btn',
      title: 'Add a Subject',
      content:
        'Click here to create a new subject (e.g. Mathematics, English). Once created, you can attach staff, classroom sections, and students to it.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-subjects-search',
      title: 'Find a Subject',
      content: 'Filter the list as you type to find a subject quickly.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-subjects-grid',
      title: 'Subject Library',
      content:
        'Each card represents a subject. Click into one to see who teaches it, which classes take it, the students enrolled, and the assessments and CBT tied to it.',
      placement: 'top',
    }),
  ],
});

registerTourPage('SubjectDetails', {
  key: 'admin-subject-details',
  label: 'Subject Details',
  getSteps: () => [
    introStep({
      title: 'Subject Details',
      content:
        'Everything for this subject in one place — assigned staff, classroom sections, and the controls to add or remove them.',
    }),
  ],
});
